import { PRICE_PRIORITY } from 'productTemplate/enums/pricePriority';
import { IOffersMap } from 'store/types/buyBarTypes';

const sortBySize = ([sizeA]: [string, any], [sizeB]: [string, any]) => {
  return (sizeA as any) - (sizeB as any);
};

const filterSizes = (sizesMap, allowedTypes) => {
  const filteredSizes = {};

  if (!sizesMap) {
    return;
  }

  for (const [size, priceInfo] of Object.entries(sizesMap)) {
    const isValidSize = allowedTypes.some((property) => priceInfo[property]);

    if (isValidSize) {
      // Filter out keys not in allowedTypes and create a new object
      const filteredPriceInfo = Object.fromEntries(
        Object.entries(priceInfo).filter(([key]) => allowedTypes.includes(key)),
      );

      filteredSizes[size] = filteredPriceInfo;
    }
  }

  return Object.entries(filteredSizes)?.sort(sortBySize);
};

export const getNew = (sizesMap) => {
  return filterSizes(sizesMap, ['bestPrice', 'instantShip', 'newWithDefects', 'newWithBoxIssues']);
};

export const getUsed = (sizesMap) => {
  return filterSizes(sizesMap, ['used']);
};

export const getOffers = (offersMap) => {
  return (Object.entries(offersMap)?.sort(sortBySize) as any as IOffersMap[]) ?? [];
};

export const getFirstOptionByPriority = (options) => {
  for (const priceOption of PRICE_PRIORITY) {
    if (options[priceOption]) {
      return options[priceOption];
    }
  }
};
